import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import api from "../../api";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { notify } from "../../utils/toast";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import axios from "axios";

export const AdminLeaves = () => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({});
  const [page, setPage] = useState(1);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (task) => setShow(true);

  const getData = async () => {
    try {
      let payload = {
        page: page,
      };
      let token = localStorage.getItem("admintoken");
      axios.defaults.headers.common["Authorization"] = token;
      const response = await api.getAllLeaves(payload);
      console.log(response);
      if (response?.success) {
        setData(response?.leaves || []);
        setPagination(response?.pagination || []);
      }
    } catch (error) {
      notify.error(error?.message || "Something went wrong");
    }
  };

  useEffect(() => {
    getData();
  }, [page]);

  return (
    <>
      {/* Begin Page Content */}
      <div className="DashboardMain">
        <div className="row">
          <div className="col">
            <h3>Time Off</h3>
            <Table
              data={data}
              getData={getData}
              pagination={pagination}
              setPage={setPage}
              page={page}
            />
          </div>
        </div>
        <div className="AddEmpBtn" onClick={handleShow}>
          <i className="fa-solid fa-plus"></i>
        </div>
      </div>
      <CreateLeaveModal
        show={show}
        handleClose={handleClose}
        getLeave={getData}
      />
      {/* /.container-fluid */}
    </>
  );
};

const Table = ({ data, page, setPage, getData, pagination }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);

  const [selectedTask, setSelectedTask] = useState({});
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (task) => {
    setSelectedTask(task);
    setShow(true);
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  const handleChange = (event, value) => {
    setPage(value);
  };

  return (
    <>
      <div className="TableMain mt-3">
        <div className="table-responsive">
          <table className="table table-hover drivers-table">
            <thead>
              <tr>
                <th scope="col" className="">
                  Name
                </th>
                <th scope="col" className="">
                  Email
                </th>
                <th scope="col" className="">
                  Start Date
                </th>
                <th scope="col" className="">
                  End Date
                </th>
                <th scope="col" className="">
                  Reason
                </th>
                <th scope="col" className="">
                  Status
                </th>
                <th scope="col" className="">
                  Created At
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, key) => (
                <tr key={key}>
                  <td>
                    <div className="table-text-dark w-max-c db">
                      {item?.employee?.fullName}
                    </div>
                  </td>

                  <td>
                    <span className="table-text-dark">
                      {item?.employee?.email}
                    </span>
                  </td>
                  <td>{item?.startDate ? formatDate(item?.startDate) : "-"}</td>
                  <td>{item?.endDate ? formatDate(item?.endDate) : "-"}</td>
                  <td>
                    <span className="table-text-dark taskDesc">
                      {item?.reason}
                    </span>
                  </td>

                  <td>
                    <span className="table-text-dark d-flex ai-center db">
                      <div className="w-max-c">
                        {item?.status == "Pending" ? (
                          <span class="badge bg-warning">{item?.status}</span>
                        ) : item?.status == "Approved" ? (
                          <span class="badge bg-success">{item?.status}</span>
                        ) : (
                          <span class="badge bg-danger">{item?.status}</span>
                        )}
                      </div>
                      <i
                        className="fa-solid fa-pen-to-square ms-2"
                        onClick={() => handleShow(item)}
                      ></i>
                    </span>
                  </td>
                  <td>
                    <div className="table-text-dark w-max-c db">
                      {item?.createdAt ? formatDate(item?.createdAt) : "-"}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="d-flex justify-content-center my-4">
          <Stack spacing={2}>
            <Pagination
              count={pagination?.pages || 1}
              page={page || 1}
              onChange={handleChange}
            />
          </Stack>
        </div>
      </div>
      <EditLeaveModal
        show={show}
        handleClose={handleClose}
        getData={getData}
        selectedTask={selectedTask}
        setSelectedTask={setSelectedTask}
      />
    </>
  );
};

const EditLeaveModal = ({
  show,
  handleClose,
  getData,
  selectedTask,
  setSelectedTask,
}) => {
  const [employees, setEmployees] = useState([]);

  const handleSubmit = async () => {
    try {
      if (!selectedTask?.status) {
        notify.warning("Status is required");

        return;
      }
      let payload = {
        status: selectedTask?.status,
        id: selectedTask?._id,
      };
      console.log(payload);
      const response = await api.updateLeaves(payload);
      console.log(response);
      if (response?.success) {
        getData();
        notify.success("Status successfully updated");

        handleClose();
      }
    } catch (error) {
      notify.error(error?.message || "Something went wrong");
    }
  };

  const onTextChange = (e) => {
    setSelectedTask({ ...selectedTask, status: e.target.value });
  };
  console.log(selectedTask);

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <div className="taskForm">
        <div className="closeIcon" onClick={handleClose}>
          <i className="fa-solid fa-xmark" />
        </div>
        <div className="h3">Edit Time Off Status</div>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <label>Reason</label>

              <div className="form-control">{selectedTask?.reason}</div>
            </div>
          </div>

          <div className="col-12">
            <div className="form-group mb-3">
              <label>Start Date</label>
              <div className="form-control">
                {selectedTask?.startDate
                  ? formatDate(selectedTask?.startDate)
                  : "-"}
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="form-group mb-3">
              <label>End Date</label>

              <div className="form-control">
                {selectedTask?.startDate
                  ? formatDate(selectedTask?.endDate)
                  : "-"}
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>Status</label>
              <select
                name="status"
                className=""
                onChange={(e) => onTextChange(e)}
                value={selectedTask?.status}
                defaultValue={selectedTask?.status}
              >
                <option value="">Select</option>
                <option value={"Pending"}>Pending</option>
                <option value={"Approved"}>Approved</option>
                <option value={"Rejected"}>Rejected</option>
              </select>
            </div>
          </div>
        </div>

        <div className="mt-4 ">
          <div className="themeBtn w-100 text-center" onClick={handleSubmit}>
            Submit
          </div>
        </div>
      </div>
    </Modal>
  );
};

const CreateLeaveModal = ({ show, handleClose, getLeave }) => {
  const [employees, setEmployees] = useState([]);
  const [data, setData] = useState({});

  const validator = () => {
    if (!data?.employeeId) {
      return "Employee id is required";
    } else if (!data?.reason) {
      return "Reason is required";
    } else if (!data?.startDate) {
      return "Start Date is required";
    } else if (!data?.endDate) {
      return "End Date is required";
    }
    return "";
  };

  const handleSubmit = async () => {
    try {
      const validatorFields = validator();

      if (validatorFields) {
        notify.warning(validatorFields);
        return;
      }
      let payload = {
        employee: data?.employeeId,
        reason: data?.reason,
        startDate: data?.startDate,
        endDate: data?.endDate,
      };
      const response = await api.addLeave(payload);
      console.log(response);
      if (response?.success) {
        getLeave();
        notify.success("Leave successfully added!");

        setData({});
        handleClose();
      }
    } catch (error) {
      notify.error(error?.message || "Something went wrong");
    }
  };

  const onTextChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const getData = async () => {
    try {
      let token = localStorage.getItem("admintoken");
      axios.defaults.headers.common["Authorization"] = token;
      const response = await api.getEmployees();
      if (response?.success) {
        setEmployees(response?.employees || []);
      }
    } catch (error) {
      notify.error("Something went wrong!");
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Modal show={show} onHide={handleClose}>
      <div className="taskForm">
        <div className="closeIcon" onClick={handleClose}>
          <i className="fa-solid fa-xmark" />
        </div>
        <div className="h3">Add Time Off</div>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <label>Employee</label>
              <select
                name="employeeId"
                className="form-control"
                onChange={onTextChange}
              >
                <option value="">Select</option>
                {employees.map((item, key) => (
                  <option value={item?._id} key={key}>
                    {item?.fullName}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-12">
            <div className="form-group">
              <label>Reason</label>
              <textarea
                rows={3}
                name="reason"
                className="form-control"
                onChange={(e) => onTextChange(e)}
              ></textarea>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="form-group">
              <label>Start Date</label>
              <input
                type="datetime-local"
                name="startDate"
                className="form-control"
                onChange={(e) => onTextChange(e)}
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="form-group">
              <label>End Date</label>
              <input
                type="datetime-local"
                name="endDate"
                className="form-control"
                onChange={(e) => onTextChange(e)}
              />
            </div>
          </div>
        </div>

        <div className="mt-4 ">
          <div className="themeBtn w-100 text-center" onClick={handleSubmit}>
            Submit
          </div>
        </div>
      </div>
    </Modal>
  );
};
